import { State, Action, StateContext } from '@ngxs/store';
import { HistoryActions } from './actions';
import { AVAILABLE_COLUMNS } from 'src/app/history/history.available-columns';
import { EmailService } from 'src/app/shared/services/email.service';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { StakeholderEmail } from 'src/app/shared/model/stakeholder-email';

export class HistoryStateModel {
  history: {
    emails: StakeholderEmail[]
    displayColumns: string[]
    skip: number
    top: number
    projectId: number
  };
}

@State<HistoryStateModel>({
  name: 'history',
  defaults: {
    history: {
      emails: [],
      displayColumns: [
        'edit',
        'preview',
        'report',
        'audit',
        'StatusDescription',
        'Subject',
        // 'SentBy',
        'SentByName',
        'SentDate',
        //'ToDesc',
        //'CCDesc',
        //'BCCDesc',
        //'Message'
      ],
      skip: 0,
      top: 20,
      projectId: 0
    }
  },
})

export class HistoryState {

  constructor(
    private emailService: EmailService
  ) {}

  @Action(HistoryActions.ToggleDisplayColumn)
  toggleDisplayColumn(ctx: StateContext<HistoryStateModel>, action: HistoryActions.HistoryAction) {
    const state = ctx.getState();
    const cols = state.history.displayColumns;
    let skip = state.history.skip;
    let top = state.history.top;
    let projectId = state.history.projectId;
    let newCols;
    if (cols.indexOf(action.payload) > -1) {
      newCols = cols.filter(x => x !== action.payload);
    } else {
      newCols = AVAILABLE_COLUMNS.map(x => x.name).filter(x => {
        return x === action.payload || cols.indexOf(x) > -1;
      });
    }
    ctx.setState({
      history: {
        emails: state.history.emails,
        displayColumns: newCols,
        skip: skip,
        top: top,
        projectId: projectId
      }
    });
  }

  @Action(HistoryActions.GetEmailList)
  getEmailList(ctx: StateContext<HistoryStateModel>, action: HistoryActions.GetEmailList) {
    const state = ctx.getState();

    let skip = action.skip == null ? state.history.skip : action.skip;
    let top = action.top == null ? state.history.top : action.top;
    let projectId = action.projectId == null ? state.history.projectId : action.projectId;

    return this.emailService.queryEmail(skip,top, projectId).pipe(
      map(emails => {

        emails = emails.map(_=>{
          //var div = document.createElement("div");
					//div.innerHTML = _.Message;
          _.Message = _.Message ? _.Message.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, " ") : '';
          return _;
        })

        ctx.setState({
          ...state,
          history: {
            ...state.history,
            emails,
            skip,
            top,
            projectId
          }});
      }),
      catchError(this.handleError));
  }

  @Action(HistoryActions.GetEmailAudit)
  getEmailAudit(ctx: StateContext<StakeholderEmail>, action: HistoryActions.GetEmailAudit) {

    return this.emailService.getAudit(action.payload).pipe(
      map(result => {
        window.location.assign(result);
      }),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = 'An error occurred:' + error.error.message;
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = error.error;
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError(errorMessage);
  }
}
